import './Apps.css';
import { Apple, Bot } from 'lucide-react';

function Apps() {
  return (
    <div className="apps">
      <section className="apps-hero">
        <div className="apps-hero-img">
          <img src="/assets/hero_img_apps.png" alt="Apps Hero Image" />
        </div>
        <div className="container">
          <div className="header">
            <h1>People First</h1>
          </div>
          <p>We build software to make an impact in people's lives.</p>
        </div>
      </section>

      <section className="apps-content">
        <div className="container">
          <div className="header">
            <h2>TAP - Find your people</h2>
            <p>Meet new people in a no-pressure way. TAP was built not to find your best friend, but to meet new people in your community. A 15 minute conversation over coffee with a someone new is a win.</p>
            <div className="buttons">
              <button onClick={() => window.open('https://apps.apple.com/us/app/tap-find-your-people/id6450863240', '_blank')} className="cta-primary">
                <Apple />
                Download for iOS
              </button>
              <button onClick={() => window.open('https://play.google.com/store/apps/details?id=smallrobot.app.tap', '_blank')} className="cta-primary">
                <Bot />
                Download for Android
              </button>
            </div>
          </div>
          <div className="app-card">
            <div className="app-img">
              <img src="/assets/tap_screens.png" alt="TAP for iOS" />
            </div>
          </div>
        </div>
      </section>

      <div className="divider" />

      <section className="apps-content">
        <div className="container">
          <div className="header">
            <h2>EDICT!</h2>
            <p>Take control of a parallel dimension in this new social platform. Issue edicts and see how it impacts your world via ground breaking journalism, impact photos, interdimensional ads and more.</p>
            <div className="buttons">
              <button className="cta-primary">
                <Apple />
                Coming soon
              </button>
              <button onClick={() => window.open('https://play.google.com/store/apps/details?id=app.smallrobot.edict&hl=en_US', '_blank')} className="cta-primary">
                <Bot />
                Download for Android
              </button>
            </div>
          </div>
          <div className="app-card">
            <div className="app-img">
              <img src="/assets/edict_screens.png" alt="TAP for iOS" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Apps;